import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import PropTypes from 'prop-types';
import AwaitButton from '../await-button/AwaitButton';

ConfirmDialogModal.propTypes = {
  title: PropTypes.node,
  action: PropTypes.func,
  cancelAction: PropTypes.func,
  content: PropTypes.node,
  icon: PropTypes.string,
  color: PropTypes.string,
  actionButton: PropTypes.string,
  manualLoading: PropTypes.bool,
  setOpenConfirm: PropTypes.func,
  openConfirm: PropTypes.bool,
  extraAction: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    color: PropTypes.string,
    variant: PropTypes.string,
  }),
};

export default function ConfirmDialogModal({
  title = 'Delete',
  content,
  action,
  cancelAction = () => null,
  icon = 'delete-outline',
  color = 'error',
  actionButton = 'Delete',
  manualLoading = null,
  setOpenConfirm,
  openConfirm,
  extraAction = null,
  ...other
}) {
  const handleCloseConfirm = (e, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    e.stopPropagation();
    cancelAction();
    setOpenConfirm(false);
  };
  const handleAction = () => {
    action();
    setOpenConfirm(false);
  };
  const handleExtraAction = () => {
    if (extraAction && typeof extraAction.onClick === 'function') {
      extraAction.onClick();
      setOpenConfirm(false);
    }
  };

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={manualLoading || openConfirm} onClose={handleCloseConfirm} {...other}>
        <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

        {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}

        <DialogActions>
          {manualLoading !== null ? (
            <LoadingButton
              variant="contained"
              color={icon === 'history-outline' ? 'primary' : color}
              loading={manualLoading}
              onClick={handleAction}
            >
              {actionButton}
            </LoadingButton>
          ) : (
            <AwaitButton
              variant="contained"
              color={icon === 'history-outline' ? 'primary' : color}
              onClick={handleAction}
            >
              {actionButton}
            </AwaitButton>
          )}

          {extraAction && (
            <Button
              variant={extraAction.variant || 'outlined'}
              color={extraAction.color || 'primary'}
              onClick={handleExtraAction}
            >
              {extraAction.label}
            </Button>
          )}

          <Button variant="outlined" color="inherit" onClick={(e) => handleCloseConfirm(e)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
